"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkAccessStatusContext = void 0;
var check_access_status_default_strategy_1 = require("./check-access-status-default.strategy");
var privateStrategy = check_access_status_default_strategy_1.checkAccessStatusDefaultStrategy;
var checkAccessStatus = function (request) {
    if (privateStrategy === null || privateStrategy === undefined) {
        console.log("privateStrategy is not initialized");
    }
    return privateStrategy.execute(request);
};
var setStrategy = function (strategy) {
    privateStrategy = strategy;
};
exports.checkAccessStatusContext = {
    checkAccessStatus: checkAccessStatus,
    setStrategy: setStrategy,
};
